import styled, { css } from "styled-components";

import { colorsPalettes, rgba, mixins, setFont } from "@similarweb/styles";
import { Box, SubTitleText } from "@similarweb/ui-components";

import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const TooltipWrapper = styled.div`
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow:
        0 0 8px rgba(0, 0, 0, 0.12),
        0 8px 8px rgba(0, 0, 0, 0.24);
    border-radius: 4px;
`;

export const HorizontalLine = styled.hr`
    height: 1px;
    width: 100%;
    background: ${colorsPalettes.carbon[100]};
    margin-block-end: 0;
    margin-block-start: 0;
    margin: 16px 0;
`;

const LegendContainer = styled.div`
    padding: 8px 0 0 24px;
    width: 223px;
    justify-content: space-between;
    > div {
        margin-bottom: 8px;
    }
`;

const ChartContainer = styled.div`
    width: calc(100% - 180px);
    height: 170px;
`;

const ChartSection = styled.div`
    padding: 10px 12px 16px 24px;
`;

export const TopSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-left: 24px;
    button {
        width: 64px;
    }
    height: 64px;
`;

export const MetricTitleWrapper = styled.div`
    margin-top: 20px;
`;

export const Container = styled(Box)`
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 24px;
`;

export const MetricsBarsContainer = styled.div`
    padding: 0 16px;
    width: 100%;
    box-sizing: border-box;
`;

const RankingDistributionSubTitle = styled(SubTitleText)`
    ${setFont({ $color: colorsPalettes.carbon[500], $size: 20 })};
`;

// tooltip styles

const LegendTableContainer = styled(FlexColumn)`
    padding: 18px 25px 42px 26px;
`;

// styles for the multi-column change tooltip
const HeadersContainerGrid = styled.div<{
    equalColumns: number;
}>`
    display: grid;
    ${({ equalColumns }) => css`
        grid-template-columns: 30% repeat(${equalColumns}, 1fr);
    `};
    padding-bottom: 9px;
`;
HeadersContainerGrid.displayName = "HeadersContainerGrid";

const TableTopContainer = styled(Box)`
    width: 100%;
    height: auto;
    border-radius: 6px 6px 0 0;
`;

const LegendTableHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 232px;
    margin-bottom: 12px;
`;

const LegendByPositionTableTitle = styled.div`
    ${mixins.setFont({ $size: 12, $weight: 500, $color: rgba(colorsPalettes.carbon[400], 1) })};
`;

const TotalKeywords = styled.div`
    ${mixins.setFont({ $size: 14, $weight: 400, $color: rgba(colorsPalettes.carbon[500], 1) })};
`;

const LegendsTableRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    width: 232px;
`;

const TooltipTitle = styled.span`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["500"])};
    font-weight: bold;
    margin-bottom: 4px;
`;

const MiniFlexTableWrapper = styled.div`
    > div {
        padding-bottom: 16px;
    }
`;

const RankingDistributionCompareModeContainer = styled(FlexColumn)`
    width: 100%;
    border-radius: 6px;
`;

const RankingDistributionCompareModeBodyWrapper = styled(FlexRow)`
    height: 220px;
    background: ${colorsPalettes.carbon[0]};
    margin-bottom: 24px;
    box-shadow: 0px 3px 6px rgba(14, 30, 62, 0.08);
    border-radius: 6px;
`;

const RankingDistributionChartWrapper = styled.div`
    flex: 1 1 232px;
    width: calc(100% - 283px);
`;

const PixelPlaceholderLoaderWrapper = styled.div`
    height: 196px;
    padding-top: 8px;
    padding-right: 8px;
    padding-left: 12px;
    padding-bottom: 8px;
`;

// TODO: Change the Change Cell itself to be aligned with the height
const ChangeCellWrapper = styled.div`
    margin-bottom: -1px;
`;

export {
    TableTopContainer,
    RankingDistributionSubTitle,
    LegendTableHeader,
    LegendByPositionTableTitle,
    LegendsTableRow,
    TotalKeywords,
    TooltipTitle,
    LegendTableContainer,
    LegendContainer,
    RankingDistributionCompareModeContainer,
    RankingDistributionCompareModeBodyWrapper,
    RankingDistributionChartWrapper,
    PixelPlaceholderLoaderWrapper,
    MiniFlexTableWrapper,
    ChangeCellWrapper,
};
